// Transforms our URL if needed to work
export const TransformUrl = link => {
  if (!link) return;
  const TransformUrl = link.replace(`${process.env.REACT_APP_FRONTEND_URI_DEV}`, "/");
  return TransformUrl;
};
